import { useEffect, useState } from 'react';
import { getFlashcardHistory } from '../../../../services/flashcards';
import { Flashcard } from '../../../../types/Flashcard';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { examsSelectors } from '../../../../slices/exams/examsSlice';
import { getYieldFilter } from '../../../../utils/examUtils';

interface FlashcardHistoryProps {
  flashcardId: string;
  isCardHistoryDrawerOpen: boolean;
}

const FlashcardHistory: React.FC<FlashcardHistoryProps> = ({
  flashcardId,
  isCardHistoryDrawerOpen,
}) => {
  const primaryExam = useSelector(examsSelectors.selectPrimaryExam);

  const [flashcard, setFlashcard] = useState<Flashcard | null>(null);

  useEffect(() => {
    if (isCardHistoryDrawerOpen) {
      fetchFlashcardHistory(flashcardId);
    }
  }, [isCardHistoryDrawerOpen, flashcardId]);

  const fetchFlashcardHistory = async (flashcardId: string) => {
    const response = await getFlashcardHistory(flashcardId);
    if (response.success) {
      setFlashcard(response.flashcard);
    }
  };

  return (
    <div className="flashcard-history">
      <h2>Card History</h2>
      <div className="flashcard-history_content">
        <div className="stat-grid">
          <div className="label">ID</div>
          <div className="value">{flashcard?.id}</div>
          <div className="label">Due On</div>
          <div className="value">
            {moment(flashcard?.scheduling.due).format('MMMM D, YYYY')}
          </div>
          <div className="label">Last Review</div>
          <div className="value">
            {moment(flashcard?.scheduling.lastReview).format('MMMM D, YYYY')}
          </div>
          <div className="label">Reps</div>
          <div className="value">{flashcard?.scheduling.reps}</div>
          <div className="label">Topics</div>
          <div className="value">
            {flashcard?.topics.map((topic) => topic.name).join(', ')}
          </div>
          <div className="label">Lapses</div>
          <div className="value">{flashcard?.scheduling.lapses}</div>
          {primaryExam && flashcard && (
            <>
              <div className="label">Yield</div>
              <div className="value">
                {flashcard[getYieldFilter(primaryExam.id)]}
              </div>
            </>
          )}
          <div className="label">Difficulty</div>
          <div className="value">
            {flashcard?.scheduling.difficulty.toFixed(2)}
          </div>
          <div className="label">Stability</div>
          <div className="value">
            {flashcard?.scheduling.stability.toFixed(2)}
          </div>
        </div>
        <div className="responses">
          <h3>Responses</h3>
          <table className="response-grid">
            <thead>
              <tr>
                <th>Response Time</th>
                <th>Rating</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              {flashcard?.responses
                ?.sort((a, b) => {
                  return moment(b.updatedAt).diff(moment(a.updatedAt));
                })
                .map((response) => (
                  <tr key={response.id}>
                    <td>
                      {moment(response.updatedAt).format('MM/DD/YY h:mm:ss A')}
                    </td>
                    <td>{response.response}</td>
                    <td>{response.duration.toFixed(2)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FlashcardHistory;
